/*
 * @Author: your name
 * @Date: 2021-11-11 15:46:45
 * @LastEditTime: 2024-12-13 16:24:58
 * @LastEditors: XuHongTao
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \do-auth-web\src\service\auth_service.ts
 */
/*
 ###############################################################################
 #                                                                             #
 # File Created: 2021-07-28 09:59:01                                           #
 #                                                                             #
 # Author: zhuxiaomin                                                          #
 #                                                                             #
 # Description:                                                                #
 #                                                                             #
 # Copyright (c) 2021 designorder.cn                                           #
 #                                                                             #
 ###############################################################################
 */
// eslint-disable-next-line import/no-unresolved
import { EnvConfig } from '@/env';
import { message } from 'ant-design-vue';
import sha256 from 'sha256';
import { post, put } from './requester';
import { getToken } from './token_util';

const workBenchPath = 'http://office.designorder.cn:9001/web-workbench/index.html#/project';

export interface ILoginParams {
    /** 是否7天免登录 */
    loginFree: boolean;
    /** 手机号 */
    phone: string;
    /** 密码 */
    password?: string;
    /** 验证码 */
    code?: string;
    /** 来源 */
    from: string;
}
export interface IPhoneLoginParams {
    /** 手机号 */
    phone: string;
    /** 验证码 */
    code: string;
    /** 来源 */
    from: string;
}
export interface IToken {
    from: string;
    token: string;
}
export interface ICrmInfo {
    description?: string;
    industry: string;
    userName: string;
    phone: string;
    customerName: string;
    source: '官网直播页面' | '官网' | '社区版注册' | 'SEM-社区版注册';
    allocated: boolean;
}
class AuthServiceImpl {
    /** 账号登录 */
    public async login(params: ILoginParams): Promise<KV> {
        let obj = {};
        if (params.password) {
            obj = {
                ...params,
                password: sha256(params.password as string),
            };
        } else {
            obj = { ...params };
        }
        const ret = await post('/authentication/login/login', obj);
        if (ret.code !== 200) {
            throw new Error(ret.msg);
        }
        return ret.data;
    }

    public isLogin(): boolean {
        return !!getToken();
    }

    // 判断用户是否登录
    public async checkIfLogin(): Promise<void> {
        const params: IToken = {
            from: 'web',
            token: getToken(),
        };
        const { code, msg, data } = await post('/authentication/login/analysisToken', params);
        // if (code === 200) {
        //     let url;
        //     const result = window.location.search.match(new RegExp('[\\?\\&]url=([^\\&]+)', 'i'));
        //     if (result === null || result.length < 1) {
        //         url = EnvConfig.getHomeUrl();
        //     } else {
        //         url = decodeURIComponent(result[1]);
        //     }
        //     window.location.href = `${url}?token=${params.token}`;
        //     throw new Error();
        // }
    }

    // 获取验证码
    public async sendCode(params: string): Promise<boolean> {
        try {
            const { code, msg } = await post('/authentication/register/sendCode', { phone: params });
            if (code !== 200) {
                message.error(msg);
                return false;
                throw new Error(msg);
            }
            return true;
        } catch {
            message.error('发送失败');
            return false;
        }
    }

    // 选择企业
    public async chooseCompany(params: KV): Promise<KV> {
        const { code, data, msg } = await post('/authentication/login/loginAndSelectGroup', params);
        if (code !== 200) {
            throw new Error(msg);
        }
        return data;
    }

    // 第一次登录设置密码
    public async firstLoginSetPwd(params: KV): Promise<void> {
        const { code, msg } = await post('/authentication/login/initUserPassword', params);
        if (code !== 200) {
            throw new Error(msg);
        }
    }

    public async forgetPwd(params: KV): Promise<void> {
        const { code, msg } = await put('/v3/sys/user/resetPassword', params);
        if (code !== 200) {
            throw new Error(msg);
        }
    }

    public async setUserInCrm(params: ICrmInfo): Promise<void> {
        const { code, msg } = await post('/v3/sys/thirdApp/sendToDingTalk', params);
        if (code !== 200) {
            throw new Error(msg);
        }
    }

    // 手机号登录
    // public async loginFromPhone(params: IPhoneLoginParams): Promise<string> {
    //     const { code, msg, data } = await post('/authentication/login/codeLogin', { ...params });
    //     if (code !== 200) {
    //         throw new Error(msg);
    //     }
    //     return data;
    // }
}

export const AuthService = new AuthServiceImpl();
